module.exports = __webpack_public_path__ + "f04fd1505f2dc426a9a89d8803c4bff0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fossil-fuel-insurance-company-table.png
// module id = 598
// module chunks = 0